export interface RequirementTypeDefault {
  readonly value: string;
  readonly i18nKey: string;
  readonly slug: string;
}

/**
 * Semantik-tragende Default-Typen. Wenn NEX-1077 einen stabilen Katalog-Code
 * einfuehrt (Review-Kommentar zu #692), wandert der Vergleich BE-seitig auf
 * dieses Feld — bis dahin bleibt der Wert der Ankerpunkt fuer parent-child
 * (SUB_TASK) und die Parent-Story-Liste (STORY).
 */
export const SUB_TASK_TYPE_VALUE = 'Sub-Task';
export const STORY_TYPE_VALUE = 'Story';

export const REQUIREMENT_TYPE_DEFAULTS: readonly RequirementTypeDefault[] = [
  { value: 'Story', i18nKey: 'STORY', slug: 'story' },
  { value: 'Bug', i18nKey: 'BUG', slug: 'bug' },
  { value: 'Sub-Task', i18nKey: 'SUBSTORY', slug: 'substory' },
  { value: 'Funktional', i18nKey: 'FUNCTIONAL', slug: 'functional' },
  { value: 'Nicht-funktional', i18nKey: 'NON_FUNCTIONAL', slug: 'non-functional' },
  { value: 'Fachlich', i18nKey: 'BUSINESS', slug: 'business' },
  { value: 'Technisch', i18nKey: 'TECHNICAL', slug: 'technical' },
] as const;

// NEX-1018 Review (fboudouhi Nachfassung): die Lookup-Tabellen laufen ueber
// Object.create(null), nicht ueber ein Objektliteral mit Object.prototype —
// sonst kollidieren externe Trackernamen wie "constructor" oder "toString" mit
// den Prototyp-Eintraegen. Praktische Folge im Rendering: der ??-Fallback greift
// nicht, statt "custom" landet der Klassenname "function Object() { ... }" im
// Template.
function nullPrototypeMap(entries: readonly (readonly [string, string])[]): Readonly<Record<string, string>> {
  const target: Record<string, string> = Object.create(null);
  for (const [k, v] of entries) target[k] = v;
  return Object.freeze(target);
}

export const REQUIREMENT_TYPE_I18N_KEYS: Readonly<Record<string, string>> = nullPrototypeMap(
  REQUIREMENT_TYPE_DEFAULTS.map((d) => [d.value, d.i18nKey] as const),
);

export const REQUIREMENT_TYPE_SLUGS: Readonly<Record<string, string>> = nullPrototypeMap(
  REQUIREMENT_TYPE_DEFAULTS.map((d) => [d.value, d.slug] as const),
);

/**
 * Stabile CSS-Slug fuer einen Vorgangstyp. Fuer die sieben Defaults kommt der
 * englische Slug aus der Mapping-Tabelle; alles andere landet auf `custom`,
 * damit das SCSS einen definierten Fallback rendern kann (statt eines
 * unsichtbaren Pill-Fragments).
 */
export function requirementTypeSlug(value: string | null | undefined): string {
  if (!value) return 'custom';
  return REQUIREMENT_TYPE_SLUGS[value] ?? 'custom';
}
